export const TOGGLE_MY_ACCOUNT = 'headerMenu/TOGGLE_MY_ACCOUNT';
